import React, { useEffect, useState, useCallback } from "react";
import AppointmentCounts from "../components/AppointmentCounts";
import AppointmentFilter from "../components/AppointmentFilter";
import AppointmentTr from "../components/AppointmentTr";
import AppointmentDetailsModal from "../components/AppointmentDetailsModal";
import AppointmentTableHead from "../components/AppointmentTableHead";
import AppointmentMobileCard from "../components/AppointmentMobileCard";
import baseUrl from "../../../../api/baseUrl";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { RootState } from "../../../../redux/store";
import {
  setAllAppointment,
  setAllAppointmentCount,
} from "../../../../redux/appointment/appointmentAction";
import { setDoctor } from "../../../../redux/doctor/doctorAction";
import BottomTab from "../../../../components/pagination/BottomTab";

const AllAppointment: React.FC = () => {
  const navigate = useNavigate();
  const [counts, setCounts] = useState(0);
  const [detailsItem, setDetailsItem] = useState<any | null>(null);
  const [doctorid, setDoctorid] = useState<any>("");
  const [all, setAll] = useState<string>("all");
  const [selectedOption, setSelectedOption] = useState<string>("pending");
  const dispatch = useDispatch();
  const appointment = useSelector((state: RootState) => state.appointment);
  const doctor = useSelector((state: RootState) => state.doctor);

  const fetchAppointments = useCallback(
    async (status: string, all: string, doctorid: string, newPage: number) => {
      try {
        const response = await baseUrl.get("/appointment/findAllAppointments", {
          headers: { status, day: all, doctorid: doctorid, page: newPage },
        });

        setCounts(response.data.count);
        dispatch(setAllAppointment(response.data.data, false));
      } catch (error) {
        console.error(error);
      }
    },
    [dispatch]
  );

  const fetchCounts = useCallback(async () => {
    try {
      const response = await baseUrl.get("/appointment/appointmentscounts", {
        headers: { status: true },
      });

      dispatch(
        setAllAppointmentCount({
          appointments: response.data?.appointments,
          cancelled: response.data?.cancelled,
          completed: response.data?.completed,
          pending: response.data?.pending,
          inqueue: response.data?.inqueue,
          reschudle: response.data?.reschudle,
          ongoing: response.data?.ongoing,
          noshow: response.data?.noshow,
        })
      );
    } catch (error) {
      console.error(error);
    }
  }, [dispatch]);

  const fetchDoctors = useCallback(async () => {
    try {
      const response = await baseUrl.get("/employee/findEmployee", {
        headers: { status: true },
      });
      dispatch(setDoctor({ data: response.data.data, empty: false }));
    } catch (error) {
      console.error(error);
    }
  }, [dispatch]);

  useEffect(() => {
    if (appointment?.allappointmentIsEMpty)
      fetchAppointments(selectedOption, all, doctorid, 1);
    if (Object.keys(appointment?.allappointmentCount).length === 0)
      fetchCounts();
    if (doctor.empty) fetchDoctors();
  }, [
    fetchAppointments,
    fetchCounts,
    fetchDoctors,
    selectedOption,
    all,
    doctorid,
    appointment?.allappointmentIsEMpty,
    appointment?.allappointmentCount,
    doctor.empty,
  ]);

  const handleOptionChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedOption(event.target.value);
    fetchAppointments(event.target.value, all, doctorid, 1);
  };

  const handleDay = (event: React.ChangeEvent<HTMLInputElement>) => {
    setAll(event.target.value);
    fetchAppointments(selectedOption, event.target.value, doctorid, 1);
  };
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setDoctorid(event.target.value);
    fetchAppointments(selectedOption, all, event.target.value, 1);
  };
  const onPageChange = useCallback(
    (newPage: number) => {
      fetchAppointments(selectedOption, all, doctorid, newPage);
    },
    [fetchAppointments, all, selectedOption, doctorid]
  );

  const refreshAfterStatusChange = useCallback(() => {
    fetchCounts();
    fetchAppointments(selectedOption, all, doctorid, 1);
  }, [fetchCounts, fetchAppointments, selectedOption, all, doctorid]);

  return (
    <div className="space-y-4">
      <AppointmentCounts count={appointment?.allappointmentCount} />

      <div className="bg-white dark:bg-slate-800 rounded-xl md:rounded-2xl shadow-lg shadow-slate-200/50 dark:shadow-slate-900/50 border border-slate-100 dark:border-slate-700 p-4 md:p-6">
        <AppointmentFilter
          selectedOption={selectedOption}
          all={all}
          handleOptionChange={handleOptionChange}
          handleDay={handleDay}
        />

        <div className="mb-4">
          <label className="block text-xs font-medium text-slate-700 dark:text-slate-300 mb-2">
            Select Doctor
          </label>
          <select
            name="doctorId"
            value={doctorid}
            onChange={(e: any) => handleChange(e)}
            className="w-full px-4 py-2.5 rounded-xl border border-slate-200 dark:border-slate-600 bg-white dark:bg-slate-700 text-slate-700 dark:text-slate-200 text-sm focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary cursor-pointer"
          >
            <option value="">All Doctors</option>
            {doctor?.doctors?.map((item: any, i: number) => {
              if (item?.IsDentist) {
                return (
                  <option key={i} value={item?._id}>
                    {item?.lastName}
                  </option>
                );
              }
              return null;
            })}
          </select>
        </div>

        {/* Desktop Table */}
        <div className="hidden md:block overflow-hidden rounded-xl border border-slate-200 dark:border-slate-600">
          <table className="w-full">
            <AppointmentTableHead />
            <tbody className="bg-white dark:bg-slate-800 divide-y divide-slate-100 dark:divide-slate-600">
              {appointment?.allappointment?.map((item: any, index: number) => (
                <AppointmentTr
                  appointmStatus={refreshAfterStatusChange}
                  key={item?._id ?? index}
                  item={item}
                />
              ))}
            </tbody>
          </table>
        </div>

        {/* Mobile Cards */}
        <div className="md:hidden space-y-3">
          {appointment?.allappointment?.map((item: any, index: number) => (
            <AppointmentMobileCard
              key={item?._id ?? index}
              item={item}
              onOpenDetails={() => setDetailsItem(item)}
              onStatusChange={refreshAfterStatusChange}
              onAddTreatment={(patientId) => {
                baseUrl
                  .post("treatment/create-treatment", { patientId })
                  .then((response) => {
                    navigate(
                      `/client/treatment-diagnose/add-treatment/diagnose/${response.data.data._id}`
                    );
                  })
                  .catch((error) => console.error(error));
              }}
            />
          ))}
          {appointment?.allappointment?.length === 0 && (
            <div className="p-8 text-center text-slate-500 dark:text-slate-400">
              <p className="text-sm">No appointments found</p>
            </div>
          )}
        </div>

        <BottomTab title="Patient" count={counts} onPageChange={onPageChange} />
      </div>

      <AppointmentDetailsModal
        item={detailsItem ?? {}}
        open={detailsItem != null}
        onClose={() => setDetailsItem(null)}
        onStatusChange={refreshAfterStatusChange}
      />
    </div>
  );
};

export default AllAppointment;
